import { RouteItem } from '@eastcoal/router/types/route'

export const auditListRoute: RouteItem = {
  title: '认证记录',
  path: '/audit/list',
  hideInMenu: true,
  Component: () => import('./index')
}
